class Constants {
  private static _instance: Constants = new Constants();
	static corporateIds: any;
  constructor() {
    if (Constants._instance) throw new Error('Use Constants.Instance');
    Constants._instance = this;
  }

  static get Instance(): any {
    return Constants._instance;
  }

  readonly fileRegExp: any = /^.*\.(jpg|JPG|png|PNG|pdf|PDF|jpeg|JPEG)$/;
  readonly denailClaimStatus : any[] = [11, 19, 23, 24];
  readonly approvedClaimStatus : any[] = [6, 58];
  readonly paidClaimStatus : any[] = [7, 22, 35];
  readonly infoAwaitedClaimStatus : any[] = [50, 58];
  readonly irUploadClaimStatus : any[] = [29, 31];
  readonly corporateIds : any[] = [1416280, 1421517, 1416318, 1320135, 1406212, 1416254, 1416316];
  readonly informationAwaited : any[] = [28, 29, 31, 27, 30, 9, 18, 59, 60, 61, 62, 63, 64, 65, 66];
  readonly scrollTopPosition: number = 190;
  readonly ONLY_DEPENDENT = "Only_Dependent";
  readonly allMonths = ['Jan','Feb','Mar', 'Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  readonly claimListFilters = ['Dependent', 'ClaimType', 'PolicyPeriod'];
  readonly healthBenefitsState = ['List', 'Benefit', 'Partner', "T&C", "TCSLocations"];
  readonly NMBCONSTANT = "NMB";
  readonly TRAVELBENEFIT = "Travel Benefit";
  readonly errorMessage = "Something went wrong"
  readonly locationTCS = [
    {name: "Bhubaneswar", vendor: "medibuddy"},
    {name:"Guwahati", vendor: "medibuddy"},
    {name:"Jamshedpur", vendor: "medibuddy"},
    {name:"Kolkata", vendor: "medibuddy"},
    {name:"Patna", vendor: "medibuddy"},
    {name:"Trivandrum", vendor: "medibuddy"},
    {name:"Raipur", vendor: "medibuddy"},
    {name:"Bangalore", vendor: "medibuddy"},
    {name:"Chennai", vendor: "medibuddy"},
    {name:"Coimbatore", vendor: "medibuddy"},
    {name:"Nagpur", vendor: "medibuddy"},
    {name: "Ahmedabad", vendor: "TATA1mg"},
    {name: "Bhopal", vendor: "TATA1mg"},
    {name: "Goa", vendor: "TATA1mg"},
    {name: "Hyderabad", vendor: "TATA1mg"},
    {name: "Indore", vendor: "TATA1mg"},
    {name: "Kochi", vendor: "TATA1mg"},
    {name: "Lucknow", vendor: "TATA1mg"},
    {name: "Mumbai", vendor: "TATA1mg"},
    {name: "New Delhi", vendor: "TATA1mg"},
    {name: "Nashik", vendor: "TATA1mg"},
    {name: "Pune", vendor: "TATA1mg"},
    {name: "Vardodara", vendor: "TATA1mg"},
    {name: "Varanasi", vendor: "TATA1mg"}
    ];
  readonly pol_categoryID  = [1,2,27,67];
}
export default Constants;